import Caption from '@zenbusiness/common-components/Caption';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const OboBanner = ({
  isMenuOpen,
  obo
}) => {
  const classes = useStyles();

  if (!obo) {
    return null;
  }

  return (
    <div
      className={classNames(classes.obo, {
        open: isMenuOpen,
        closed: !isMenuOpen
      })}
    >
      <Caption align="center" className={classes.oboLabel} tag="p">
        {`On behalf of ${obo}`}
      </Caption>
    </div>
  );
};

OboBanner.propTypes = {
  isMenuOpen: PropTypes.bool,
  obo: PropTypes.string
};

OboBanner.defaultProps = {
  isMenuOpen: false,
  obo: null
};

export default OboBanner;
